import axios from 'axios';
import Vue from 'vue';

const getDefaultState = () => {
  return {
    accessToken: null,
    user_info: {
      userId: '',
      userName: '',
      deviceGroupType: '',
      deviceGroupId: '',
      admin: false,
      isMap: false,
    },
  };
};

export default {
  // ネームスペースを利用する
  namespaced: true,
  state: getDefaultState(),
  getters: {
    access_token: (state) => {
      return state.accessToken;
    },
    user_info: (state) => {
      return state.user_info;
    },
  },
  mutations: {
    set_access_token(state, payload) {
      state.accessToken = payload;
    },
    set_user_info(state, payload) {
      state.user_info = { ...state.user_info, ...payload };
    },
    clear_state(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async get_access_token({ commit }, loginInfo) {
      if (process.env.NODE_ENV === 'production') {
        const { msal } = loginInfo;
        while (!msal.data.accessToken) {
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
        commit('set_access_token', msal.data.accessToken);
      } else {
        const { userName, password } = loginInfo;
        commit('set_user_info', {
          userId: userName,
          userName: userName.replace(/@.*$/, ''),
        });
        const url = `https://login.microsoftonline.com/${process.env.VUE_APP_TENANT_ID}/oauth2/v2.0/token`;
        const params = new URLSearchParams();
        params.append('grant_type', process.env.VUE_APP_GRANT_TYPE);
        params.append('tenant_id', process.env.VUE_APP_TENANT_ID);
        params.append('client_id', process.env.VUE_APP_CLIENT_ID);
        params.append('scope', process.env.VUE_APP_SCOPE);
        params.append('client_secret', process.env.VUE_APP_CLIENT_SECRET);
        params.append('username', userName);
        params.append('password', password);
        await axios
          .post(url, params)
          .then(async (responce) => {
            commit('set_access_token', responce.data.access_token);
          })
          .catch((e) => {
            throw new Error(e);
          });
      }
    },
    async get_user_info({ commit }, users) {
      const { username, name } = users;
      const vueIns = new Vue();
      // ユーザ・ロール取得
      const userRoles = await vueIns.apiRequest('/v1/master-info/userRoles', 'GET', {
        user_id: username,
      });

      // userRoles配列の要素にrole_idにgwC2dSendUpdが含まれていたらisMapをtrueにする
      const isMap = userRoles.some((userRole) => userRole.role_id.indexOf('gwC2dSendUpd') >= 0);

      // ログインロールのIDを取得
      const loginRole = userRoles.filter((userRole) => userRole.role_id.indexOf('Login') > 0);

      // ルート設備参照権限取得
      const roleRootGroups = await vueIns.apiRequest('/v1/master-info/roleRootGroups', 'GET', {
        role_id: loginRole[0].role_id,
      });

      // デバイスグループを取得
      const rootGroupId = roleRootGroups[0].root_group_id;
      const deviceGroupType = rootGroupId.replace('$', '');
      const deviceGroups = await vueIns.apiRequest('/v1/master-info/deviceGroups', 'GET', {
        device_group_type: deviceGroupType,
      });

      // 子のデバイスグループがいなければ需要家画面へ
      // 子のデバイスグループがいれば需要家以外のトップ画面へ遷移
      const childDeviceGroup = deviceGroups.filter((deviceGroup) => deviceGroup.parent_device_group_id === rootGroupId);

      const userInfo = {
        userId: username,
        userName: name,
        deviceGroupType: deviceGroupType,
        deviceGroupId: rootGroupId,
        admin: Boolean(childDeviceGroup.length !== 0),
        isMap: isMap,
      };
      commit('set_user_info', userInfo);
    },
  },
};
